/*global jQuery, google */
(function($) {

  'use strict';

  $(function() {
	  $('#filter-galleria').on('change', function(){
	  	var tipo = $(this).val();

	  	$('.tipogalleria').addClass('d-none');
	  	$('.'+tipo).removeClass('d-none');

	  });

  });

}(jQuery));